import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import styles from './style.module.scss';
import { useTranslation } from '@hooks/index';

export interface IBulkUpdateProps {
    tooltip?: string;
}

const BulkUpdateIcon = ({ tooltip }: IBulkUpdateProps) => {
    const { t } = useTranslation();

    return (
        <div className={cn('k-d-flex fa-stack', styles.iconStyle)}>
            <FontAwesomeIcon
                className={cn('fa-stack-1x')}
                fontSize={16}
                icon={['far', 'layer-group']}
                aria-label={`${tooltip || t('bulkUpdate')}`}
            />
            <FontAwesomeIcon
                className={cn('fa-stack-1x')}
                fontSize={12}
                icon={['far', 'pencil']}
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '0.5px 0px',
                    position: 'absolute',
                    top: '30%',
                    left: '55%',
                }}
                aria-label={`${tooltip || t('bulkUpdate')}`}
            />
        </div>
    );
};

export default BulkUpdateIcon;
